// extracted by css-extract-rspack-plugin
export default {"swiperWrapper":"_e296c5e6","swiperItem":"_eb5447a0"};